import React from "react";
import { useHistory } from "react-router-dom";
import PageHeader from "../../organisms/PageHeader/PageHeader";
import FullPageLoader from "../../organisms/FullPageLoader/FullPageLoader";

const OnePageLayout = ({ children }) => {
    const history = useHistory();
    const { pathname } = history.location;

    return (
        <div className="main-container">
            <FullPageLoader />
            <PageHeader />
            <div className={`page-content ${pathname === '/working-hours' ? 'no-padding' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default OnePageLayout;
